
import React from 'react';
import { get, getOr } from 'lodash/fp';
import { FieldConfig, Field as FormikField, FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

export type FieldProps<T, P = unknown> = {
    name: string;
    formikProps: FormikProps<T>;
    renderer: FieldConfig<T & P>['as'];
    label?: string;
    children?: React.ReactNode[];
} & P;

const Field = <T, P>({
    name, label, formikProps: { errors, touched, handleChange }, renderer, ...other
}: FieldProps<T, P>) => {
    const { t } = useTranslation();

    return (
        <FormikField
            id={name}
            name={name}
            label={label}
            as={renderer}
            error={Boolean(get(name, errors)) && get(name, touched)}
            helpertext={get(name, touched) ? t(getOr(' ', name, errors)) : ' '}
            variant="outlined"
            onChange={handleChange}
            {...other}
        />
    );
};

export default Field;
